export default __webpack_public_path__ + "src/images/home_text-8a05fe.png";